import script from "./badge-listing-img.vue?vue&type=script&setup=true&lang=js"
export * from "./badge-listing-img.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__